export default class Columns {	
	/* Thanks to CSS Tricks for pointing out this bit of jQuery
       http://css-tricks.com/equal-height-blocks-in-rows/
       It's been modified into a function called at page load and then each time the page is resized. One large modification was to remove the set height before each new calculation. */

	constructor(columns, match) {
		this.columns = columns;
		this.match = match;

		this.currentTallest = 0;
		this.currentRowStart = 0;
		this.rowDivs = [];
	}

	equalheight() {
        var topPosition = 0;

        let ColScope = this;

        $(this.columns).each(function() {
           let $el = $(this);

           $el.height('auto');

           let topPostion = $el.position().top;

           	if (ColScope.currentRowStart != topPostion) {
	            for (let currentDiv = 0 ; currentDiv < ColScope.rowDivs.length ; currentDiv++) {
	               	ColScope.rowDivs[currentDiv].height(ColScope.currentTallest);
	            }

				ColScope.rowDivs.length = 0; // empty the array
				ColScope.currentRowStart = topPostion;
				ColScope.currentTallest = $el.height();
				ColScope.rowDivs.push($el);
           	} else {
				ColScope.rowDivs.push($el);
				ColScope.currentTallest = (ColScope.currentTallest < $el.height()) ? ($el.height()) : (ColScope.currentTallest);
          	}

			for (let currentDiv = 0 ; currentDiv < ColScope.rowDivs.length ; currentDiv++) {
				ColScope.rowDivs[currentDiv].height(ColScope.currentTallest);

				if((currentDiv+1) >= ColScope.rowDivs.length) ColScope.setMatchingColHeights();
			}
        });
    }

    setMatchingColHeights() {
    	if(typeof this.match === undefined) return false;

        let ColScope = this;

    	$(this.match).each(function() {
			$(this).height(ColScope.currentTallest);
    	});
    }
};


// WEBPACK FOOTER //
// ./scripts/util/columnConform.js